module.exports = __webpack_public_path__ + "static/media/onboardingIntercom.ad7e363d.png";